
import { useEffect, useRef, useState } from "react";
import env from "shared/config/env";
import io from "socket.io-client";

const useGameSocket = (roomCode, userName, inputCode) => {
    const [isJoined, setIsJoined] = useState(false);
    const [players, setPlayers] = useState([]);
    const [myNumbers, setMyNumbers] = useState([]);
    const [allPlayersData, setAllPlayersData] = useState(null);
    const [hasRolled, setHasRolled] = useState(false);
    const [isRolling, setIsRolling] = useState(false);
    const serverNumbersRef = useRef(null);
    const minTimeElapsed = useRef(false);
    const socketRef = useRef(null);

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            socketRef.current?.disconnect();
        };
    }, []);

    // Rolling animation effect
    useEffect(() => {
        let interval;
        if (isRolling) {
            interval = setInterval(() => {
                setMyNumbers(
                    Array.from({ length: 5 }, () => Math.floor(Math.random() * 6) + 1)
                );
            }, 80);
        }
        return () => clearInterval(interval);
    }, [isRolling]);

    const checkRollComplete = () => {
        if (minTimeElapsed.current && serverNumbersRef.current) {
            setIsRolling(false);
            setMyNumbers(serverNumbersRef.current);
            setHasRolled(true);
        }
    };

    const joinRoom = () => {
        if (inputCode) {
            socketRef.current = io(env.baseUrl, {
                transports: ["websocket"],
                withCredentials: true,
            });

            socketRef.current.emit("join_room", {
                roomCode,
                password: inputCode,
                playerName: userName,
            });

            socketRef.current.on("update_player_list", (list) => setPlayers(list));
            socketRef.current.on("update_game_numbers", (data) => {
                serverNumbersRef.current = data.numbers;
                checkRollComplete();
            });
            socketRef.current.on("all_numbers_revealed", (data) => {
                setAllPlayersData(data);
                setHasRolled(false);
                // Note: runConfetti() logic needs to be handled in the UI component as it's visual
            });
            socketRef.current.on("force_leave_room", () => {
                exitRoom();
                alert("ห้องถูกรีเซ็ตแล้ว");
            });
            setIsJoined(true);
            return true; // Indicate success
        }
        return false;
    };

    const exitRoom = () => {
        socketRef.current?.disconnect();
        setIsJoined(false);
        setMyNumbers([]);
        setAllPlayersData(null);
        setHasRolled(false);
        setIsRolling(false);
    };

    const rollDice = () => {
        setIsRolling(true);
        setHasRolled(false);
        serverNumbersRef.current = null;
        minTimeElapsed.current = false;

        socketRef.current.emit("request_random_numbers", roomCode);

        setTimeout(() => {
            minTimeElapsed.current = true;
            checkRollComplete();
        }, 1000);
    };

    const revealAll = () => {
        setHasRolled(false);
        socketRef.current.emit("reveal_all_numbers", roomCode);
    };

    const resetRoom = () => {
        if (window.confirm("ล้างห้อง?")) {
            socketRef.current.emit("delete_all_room_data", roomCode);
        }
    };

    return {
        isJoined,
        players,
        myNumbers,
        allPlayersData,
        hasRolled,
        isRolling,
        socketRef,
        joinRoom,
        exitRoom,
        rollDice,
        revealAll,
        resetRoom,
    };
};

export default useGameSocket;
